export default __webpack_public_path__ + "static/media/indexx trade to earn.d6f28594.png";